import { render, staticRenderFns } from "./paper.vue?vue&type=template&id=3c27f894&scoped=true&"
import script from "./paper.vue?vue&type=script&lang=js&"
export * from "./paper.vue?vue&type=script&lang=js&"
import style0 from "./paper.vue?vue&type=style&index=0&id=3c27f894&prod&lang=less&scoped=true&"
import style1 from "./paper.vue?vue&type=style&index=1&id=3c27f894&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c27f894",
  null
  
)

export default component.exports